import { render, staticRenderFns } from "./SwitchApplication.vue?vue&type=template&id=48b88aef&scoped=true"
import script from "./SwitchApplication.vue?vue&type=script&lang=js"
export * from "./SwitchApplication.vue?vue&type=script&lang=js"
import style0 from "./SwitchApplication.vue?vue&type=style&index=0&id=48b88aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b88aef",
  null
  
)

export default component.exports